import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllManagers,} from "./functions";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";

const Managers = () => {
    const [isLoading , setIsLoading] = useState(true);
    const [allManagers , setAllManagers] = useState([]);

    useEffect(() => {
        (async () => {
            const allManagers = await getAllManagers();
            console.log(allManagers);
            setAllManagers(allManagers);
            document.title = "مدیریت مدیران اپلیکیشن"
            setIsLoading(false);
        })();

    } , []);

    if (isLoading)
        return <Loading />

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت مدیران اپلیکیشن</h1>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                            <table className={"table text-center"}>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>آیدی</th>
                                    <th>نام</th>
                                    <th>سطح دسترسی</th>
                                    <th>شماره تماس فعال</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    allManagers.map((manager , index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{manager.id}</td>
                                                <td>{(manager.person.sex == "MALE" ? "آقای " : "خانم ") + manager.person.firstname + " " + manager.person.lastname}</td>
                                                <td>{manager.accessibility == "OWNER" ? "مالک" : "مدیر"}</td>
                                                <td>{manager.person.activePhonenumber}</td>
                                                <td>
                                                    <Link to={`update/${manager.id}`}>
                                                        <FontAwesomeIcon className={"btn"} icon={faPencil} width={20}/>
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link to={`update/${manager.id}`}>
                                                        <FontAwesomeIcon className={"btn"} icon={faTrash} width={20}/>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default Managers;